// ======================================================================
// File Name       : user
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

// USER
export const USER_RECEIVE_USER_LIST = 'USER_RECEIVE_USER_LIST';
export const USER_RECEIVE_GROUP_LIST = 'USER_RECEIVE_GROUP_LIST';
export const USER_RECEIVE_AUTHORITY_LIST = 'USER_RECEIVE_AUTHORITY_LIST';
export const USER_RECEIVE_ATTRIBUTE_LIST = 'USER_RECEIVE_ATTRIBUTE_LIST';
export const USER_RECEIVE_GROUP_RELATION_LIST = 'USER_RECEIVE_GROUP_RELATION_LIST';
export const USER_RECEIVE_CHILD_USER_LIST = 'USER_RECEIVE_CHILD_USER_LIST';
export const USER_RECEIVE_RELATION_LIST = 'USER_RECEIVE_RELATION_LIST';
export const USER_RECEIVE_COURSE_LIST = 'USER_RECEIVE_COURSE_LIST';
export const USER_EDIT = 'USER_EDIT';
export const EDIT_CHILD_USER_LIST = 'EDIT_CHILD_USER_LIST';
export const STORE_USER_LIST_ON_DIALOG = 'STORE_USER_LIST_ON_DIALOG';
export const STORE_MY_USER_INFO = 'STORE_MY_USER_INFO';
export const USER_COURSE_RELATION_LIST = 'USER_COURSE_RELATION_LIST';
export const REMOVED_USER_IN_DIALOG = 'REMOVED_USER_IN_DIALOG';
export const AUTHORITY_USER_LOGING = 'AUTHORITY_USER_LOGING';
export const REMOVED_DATA_USER_HAS_GROUP_AND_ROLE = 'REMOVED_DATA_USER_HAS_GROUP_AND_ROLE';
export const USER_GROUP_RELATION_USER_LOGING = 'USER_GROUP_RELATION_USER_LOGING';
export const GET_GROUP_COURSE_RELATION = 'GET_GROUP_COURSE_RELATION';
export const RECEIVE_ALL_GROUP = 'RECEIVE_ALL_GROUP';
export const GET_MANAGEMENT_USER_INFO = 'GET_MANAGEMENT_USER_INFO';
